module.exports = __webpack_public_path__ + "img/emptystate-visit-windows.205ccdc1.svg";